import React from 'react';
import {AuthedLayout} from 'components/Layout';

const DashboardLazy = React.lazy(() => import(/* webpackChunkName: "RolesDashboard" */ './Dashboard'));

export const Dashboard = props => <AuthedLayout component={DashboardLazy} {...props} />;
